import { render } from "./QuestionDescriptive.vue?vue&type=template&id=537998b4&scoped=true&ts=true"
import script from "./QuestionDescriptive.vue?vue&type=script&lang=ts"
export * from "./QuestionDescriptive.vue?vue&type=script&lang=ts"

import "./QuestionDescriptive.vue?vue&type=style&index=0&id=537998b4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537998b4"]])

export default __exports__